import { DemoInvoiceUnit } from '../enums/demoInvoiceUnit'

export const demoInvoiceUnits: DemoInvoiceUnit[] = Object.values(DemoInvoiceUnit)
